import { render } from "./ToggleDoubleLabel.vue?vue&type=template&id=0b59d2a6&scoped=true"
import script from "./ToggleDoubleLabel.vue?vue&type=script&lang=js"
export * from "./ToggleDoubleLabel.vue?vue&type=script&lang=js"

import "./ToggleDoubleLabel.vue?vue&type=style&index=0&id=0b59d2a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b59d2a6"]])

export default __exports__